angular.module('taric.patterns', [])
    .component('backgroundPattern01', require('./components/background-pattern-01'))
    .component('backgroundPattern02', require('./components/background-pattern-02'))
    ;